/* eslint-disable jira/filename-case */
export const AGILITY_BACKLOG = 'agility-backlog';
export const BITBUCKET_ISSUE = 'bitbucket-issue';
export const CONNECT_ISSUE = 'connect-issue';

/** Issue in a JWM/Business project, loaded in a full page. JWM equivalent of full-issue. */
export const CORE_ISSUE = 'core-issue';
/** Issue in the Board view of a Jira project */
export const JIRA_BOARD = 'jira-board';
/** Issue in a JWM/Business project, loaded in the Calendar tab, as modal or sidebar */
export const JIRA_CALENDAR = 'jiraCalendar';
/** Issue in a JWM/Business project, loaded in the Timeline tab, as modal or sidebar */
export const JIRA_TIMELINE = 'jiraTimeline';
/** Issue in a JWM/Business project, loaded in the Calendar tab, as modal or sidebar */
export const BUSINESS_CALENDAR = 'business-calendar';
/** Issue in a JWM/Business project, loaded in the List tab, as modal or sidebar */
export const BUSINESS_LIST = 'business-list';
/** Issue in a JWM/Business project, loaded in the Timeline tab, as modal or sidebar */
export const BUSINESS_TIMELINE = 'business-timeline';
/** Issue in a JWM/Business project, loaded in the Board tab, as modal or sidebar */
export const BUSINESS_BOARD = 'business-board';
/** Issue in a JWM/Business project, loaded in the Approvals tab, as modal or sidebar */
export const BUSINESS_APPROVALS = 'business-approvals';
/** Issue in a JWM/Business project, loaded in the Files tab, as modal or sidebar */
export const BUSINESS_FILES = 'business-files';

/** Issue in a JSW/Software project, loaded in a full page */
export const FULL_ISSUE = 'full-issue';
/** Service request in a JSM project, loaded in the modernised Work Item View full page */
export const JSM_FULL_ISSUE = 'jsm-full-issue';
export const EMBED_ISSUE = 'embed-issue';
export const WORK_ITEM_VIEW = 'work-item-view';
export const GLOBAL_ISSUE_NAVIGATOR_ISSUE = 'global-issue-navigator-issue';
export const MOBILE_ISSUE = 'mobile-issue';
export const PROJECT_ISSUE_NAVIGATOR = 'project-issue-navigator';
export const STANDARD_ROADMAP_ISSUE = 'roadmap-issue';
export const SIMPLE_SOFTWARE_BOARD = 'simple-software-board';
export const SOFTWARE_BACKLOG_ISSUE = 'software-backlog-issue';
export const SOFTWARE_DEPLOYMENTS_ISSUE = 'software-deployments-issue';
export const SOFTWARE_VERSION_DETAILS_ISSUE = 'version-detail-issue';
export const SOFTWARE_CYCLE_TIME_REPORT_ISSUE = 'software-cycle-time-report-issue';
export const SOFTWARE_INCIDENTS_ISSUE = 'software-incidents-issue';
export const SOFTWARE_ISSUE = 'software-issue';
export const SERVICEDESK_CHANGE_CALENDAR = 'change-calendar';
export const SERVICEDESK_QUEUES_ISSUE = 'queues-issue-view';
export const SERVICEDESK_LIVE_CHAT_ISSUE = 'live-chat-issue-view';
export const SERVICEDESK_REPORTS_ISSUE = 'reports-issue-view';
export const FORGE_FULL_PAGE_EXTENSION = 'forge-full-page-extension';
export const ISSUE_NAVIGATOR = 'issue-navigator-next';
export const ISSUE_NAVIGATOR_DETAIL_VIEW = 'issue-navigator-detail-view';
export const CLASSIC_SOFTWARE_BOARD = 'classic-software-board';
export const JIRA_HOME_RECOMMENDED = 'jira-home-recommended';
export const GLOBAL_ISSUE_CREATE = 'global-issue-create';

/** Issue in CSM project, loaded in sidebar */
export const CSM_LIVE_CONVERSATION_ISSUE = 'csm-live-conversation-issue-view';

/** Issue in HAM (Hardware Asset Management) Work Items table */
export const HAM_WORK_ITEMS = 'ham-work-items';

/** Issue in Agents Watchtower sidebar */
export const AGENTS_WATCHTOWER = 'agents-watchtower';

export type AnalyticsSource =
	| typeof AGILITY_BACKLOG
	| typeof BITBUCKET_ISSUE
	| typeof CONNECT_ISSUE
	| typeof CORE_ISSUE
	| typeof BUSINESS_APPROVALS
	| typeof BUSINESS_BOARD
	| typeof BUSINESS_CALENDAR
	| typeof BUSINESS_LIST
	| typeof BUSINESS_FILES
	| typeof BUSINESS_TIMELINE
	| typeof EMBED_ISSUE
	| typeof FULL_ISSUE
	| typeof JSM_FULL_ISSUE
	| typeof GLOBAL_ISSUE_NAVIGATOR_ISSUE
	| typeof JIRA_BOARD
	| typeof JIRA_CALENDAR
	| typeof JIRA_TIMELINE
	| typeof MOBILE_ISSUE
	| typeof PROJECT_ISSUE_NAVIGATOR
	| typeof STANDARD_ROADMAP_ISSUE
	| typeof SIMPLE_SOFTWARE_BOARD
	| typeof SOFTWARE_BACKLOG_ISSUE
	| typeof SOFTWARE_DEPLOYMENTS_ISSUE
	| typeof SOFTWARE_CYCLE_TIME_REPORT_ISSUE
	| typeof SOFTWARE_INCIDENTS_ISSUE
	| typeof SOFTWARE_ISSUE
	| typeof SERVICEDESK_CHANGE_CALENDAR
	| typeof SERVICEDESK_QUEUES_ISSUE
	| typeof SERVICEDESK_LIVE_CHAT_ISSUE
	| typeof SERVICEDESK_REPORTS_ISSUE
	| typeof SOFTWARE_VERSION_DETAILS_ISSUE
	| typeof FORGE_FULL_PAGE_EXTENSION
	| typeof ISSUE_NAVIGATOR
	| typeof ISSUE_NAVIGATOR_DETAIL_VIEW
	| typeof CLASSIC_SOFTWARE_BOARD
	| typeof JIRA_HOME_RECOMMENDED
	| typeof GLOBAL_ISSUE_CREATE
	| typeof CSM_LIVE_CONVERSATION_ISSUE
	| typeof HAM_WORK_ITEMS
	| typeof AGENTS_WATCHTOWER;
